var _rect, _path, _g, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCanvasNavSlideVertically = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.167969,
    width: 56,
    height: 56,
    rx: 10,
    fill: "#9C64FF",
    fillOpacity: 0.25
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.8558 19.47V21.8376M28.8558 36.0431C34.0861 36.0431 38.3261 31.8031 38.3261 26.5728V21.8376C38.3261 16.6072 34.0861 12.3672 28.8558 12.3672C23.6254 12.3672 19.3854 16.6072 19.3854 21.8376V26.5728C19.3854 31.8031 23.6254 36.0431 28.8558 36.0431Z",
    stroke: "#50307E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_4145_3571)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-3-inside-1_4145_3571",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.3297 22.1145C29.3297 20.4503 30.6788 19.1012 32.343 19.1012C34.0072 19.1012 35.3563 20.4503 35.3563 22.1145V29.3981C37.4527 29.5857 39.7595 29.9252 41.1176 30.2647C43.1479 30.7723 45.6858 32.5738 45.6858 35.3405L45.6858 39.4012C45.6858 40.9239 45.2779 46.0004 37.6144 46.0004C34.4633 46.0004 32.6079 45.223 31.5154 43.9567L23.9624 36.4038C22.7856 35.227 22.7856 33.3191 23.9624 32.1423C25.1392 30.9655 27.0471 30.9655 28.2239 32.1423L29.3297 33.2482V22.1145Z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.3297 22.1145C29.3297 20.4503 30.6788 19.1012 32.343 19.1012C34.0072 19.1012 35.3563 20.4503 35.3563 22.1145V29.3981C37.4527 29.5857 39.7595 29.9252 41.1176 30.2647C43.1479 30.7723 45.6858 32.5738 45.6858 35.3405L45.6858 39.4012C45.6858 40.9239 45.2779 46.0004 37.6144 46.0004C34.4633 46.0004 32.6079 45.223 31.5154 43.9567L23.9624 36.4038C22.7856 35.227 22.7856 33.3191 23.9624 32.1423C25.1392 30.9655 27.0471 30.9655 28.2239 32.1423L29.3297 33.2482V22.1145Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.3563 29.3981H33.3563V31.2271L35.1781 31.3901L35.3563 29.3981ZM41.1176 30.2647L41.6027 28.3245L41.1176 30.2647ZM45.6858 35.3405H43.6858V35.3406L45.6858 35.3405ZM45.6858 39.4012H47.6858V39.4012L45.6858 39.4012ZM31.5154 43.9567L33.0297 42.6502L32.9816 42.5945L32.9296 42.5425L31.5154 43.9567ZM23.9624 36.4038L22.5482 37.818H22.5482L23.9624 36.4038ZM23.9624 32.1423L25.3766 33.5565L25.3766 33.5565L23.9624 32.1423ZM28.2239 32.1423L26.8097 33.5565H26.8097L28.2239 32.1423ZM29.3297 33.2482L27.9155 34.6624L31.3297 38.0766V33.2482H29.3297ZM32.343 17.1012C29.5743 17.1012 27.3297 19.3457 27.3297 22.1145H31.3297C31.3297 21.5548 31.7834 21.1012 32.343 21.1012V17.1012ZM37.3563 22.1145C37.3563 19.3457 35.1118 17.1012 32.343 17.1012V21.1012C32.9027 21.1012 33.3563 21.5548 33.3563 22.1145H37.3563ZM37.3563 29.3981V22.1145H33.3563V29.3981H37.3563ZM41.6027 28.3245C40.1011 27.9491 37.6785 27.5979 35.5346 27.4061L35.1781 31.3901C37.2268 31.5735 39.418 31.9014 40.6325 32.205L41.6027 28.3245ZM47.6858 35.3405C47.6858 33.2951 46.7357 31.662 45.5539 30.5183C44.3925 29.3943 42.9297 28.6562 41.6027 28.3245L40.6325 32.205C41.3358 32.3809 42.1571 32.7973 42.7722 33.3926C43.367 33.9682 43.6858 34.6192 43.6858 35.3405H47.6858ZM47.6858 39.4012L47.6858 35.3405L43.6858 35.3406L43.6858 39.4012L47.6858 39.4012ZM37.6144 48.0004C41.9285 48.0004 44.6219 46.5405 46.1422 44.4471C47.5766 42.472 47.6858 40.3014 47.6858 39.4012H43.6858C43.6858 40.0237 43.5911 41.1527 42.9057 42.0966C42.3061 42.9221 40.9638 44.0004 37.6144 44.0004V48.0004ZM30.0011 45.2632C31.6268 47.1474 34.1666 48.0004 37.6144 48.0004V44.0004C34.7601 44.0004 33.5891 43.2986 33.0297 42.6502L30.0011 45.2632ZM32.9296 42.5425L25.3766 34.9895L22.5482 37.818L30.1012 45.371L32.9296 42.5425ZM25.3766 34.9895C24.9809 34.5938 24.9809 33.9522 25.3766 33.5565L22.5482 30.7281C20.5904 32.6859 20.5904 35.8601 22.5482 37.818L25.3766 34.9895ZM25.3766 33.5565C25.7723 33.1608 26.4139 33.1608 26.8097 33.5565L29.6381 30.7281C27.6803 28.7703 24.506 28.7703 22.5482 30.7281L25.3766 33.5565ZM26.8097 33.5565L27.9155 34.6624L30.7439 31.834L29.6381 30.7281L26.8097 33.5565ZM27.3297 22.1145V33.2482H31.3297V22.1145H27.3297Z",
    fill: "#50307E",
    mask: "url(#path-3-inside-1_4145_3571)"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6501 32.1324L12.6501 16.1324M12.6501 32.1324L14.6501 30.1324M12.6501 32.1324L10.6501 30.1324M12.6501 16.1324L10.6501 18.1324M12.6501 16.1324L14.6501 18.1324",
    stroke: "#50307E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_4145_3571",
    x: 17.0798,
    y: 13.1012,
    width: 42.606,
    height: 46.8993,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.313726 0 0 0 0 0.188235 0 0 0 0 0.494118 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4145_3571"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4145_3571",
    result: "shape"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCanvasNavSlideVertically);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/canvas_nav_slide_vertically.349e0a4f9286feddc141fb0a5cd8eb6f.svg";